import getAttachmentSuggestionsAction from '../actions/getAttachmentSuggestionsAction';
import getContextualMRUSuggestionsAction from '../actions/getContextualMRUSuggestionsAction';
import getMRUSuggestionsAction from '../actions/getMRUSuggestionsAction';
import getReplyWithSuggestionsAction from '../actions/getReplyWithSuggestionsAction';
import {
    shouldFetchContextualMRUAttachmentSuggestions,
    attachmentSuggestionsEnabled,
} from '../utils/getAttachmentTypesToFetch';
import { orchestrator } from 'satcheljs';

export default orchestrator(getAttachmentSuggestionsAction, actionMessage => {
    if (attachmentSuggestionsEnabled()) {
        if (shouldFetchContextualMRUAttachmentSuggestions() && actionMessage.referenceItemId) {
            getContextualMRUSuggestionsAction(actionMessage.referenceItemId);
        } else {
            getReplyWithSuggestionsAction(actionMessage.referenceItemId);
            getMRUSuggestionsAction();
        }
    }
});
